<template>
  <div class="container">

    <div class="page-content--body">
      <div class="page-content--body-right">
        <div class="chat">
          <v-card outlined class="chat--manager">
            <v-list three-line class="chat--manager-list">
              <v-list-item-group
                v-model="selected"
                active-class="primary--text"
              >
              <template v-for="(item, index) in items">
                <v-list-item :key="item.title" class="chat--manager-list--point">
                  <template v-slot:default="{ active }">
                    <div class="chat--manager-list--info">
                      <div class="chat--manager-list--info-name" v-html="item.title"></div>
                      <div class="chat--manager-list--info-position" v-html="item.subtitle"></div>
                      <div class="chat--manager-list--info-time">
                        <v-icon size="16" color="#8F95B2">mdi-clock-outline</v-icon>
                        {{item.time}}
                      </div>
                      <div class="chat--manager-list--info-label">
                        <v-chip :class="item.labelBackground" :text-color="item.labelColor">{{item.label}}</v-chip>
                      </div>
                    </div>

                    <div class="chat--manager-list--star">
                      <v-icon color="primary" v-if="active">mdi-star-outline</v-icon>
                      <v-icon color="#8F95B2" v-else>mdi-star-outline</v-icon>
                    </div>
                  </template>
                </v-list-item>
              </template>
              </v-list-item-group>
            </v-list>
          </v-card>

          <div class="chat--action">

            <div class="chat--action-head">
              <div class="chat--action-head-avatar">
                <div class="chat--action-head-avatar-name">Заголовок обращения</div>
              </div>
              <div class="chat--action-head-buttons">
                <v-btn class="mx-1" fab small color="#fff" elevation="0">
                  <v-icon color="#8F95B2">mdi-dots-vertical</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="chat--action-body">
              <v-spacer></v-spacer>
              <div v-for="(item, index) in chat" :key="index"
                   :class="['d-flex flex-row', item.from === 'user' ? 'justify-end user': 'manager']">
                <span v-if="item.from === 'user'" class="message">{{ item.msg }}</span>
                <div v-if="item.from !== 'user'" class="manager-avatar">
                  <img alt="" src="/static/manager02.jpg" />
                </div>
                <span v-if="item.from !== 'user'" class="message">{{ item.msg }}</span>
              </div>
            </div>

            <div class="chat--action-footer">
              <div class="d-flex flex-row align-center">
                <v-text-field
                  v-model="msg"
                  placeholder="Ваше сообщение"
                  @keypress.enter="send"
                  outlined
                  dense
                  hide-details
                  @click:append="send"
                  @click:prepend-inner="addFile"
                  prepend-inner-icon="mdi-paperclip"
                  append-icon="mdi-send"
                ></v-text-field>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Page5',
  data() {
    return {
      selected: false,
      items: [
        {
          title: 'Заголовок обращения',
          subtitle: 'Обращение № 1',
          time: 'Сегодня | 16:30',
          label: 'Открыто',
          labelColor: '#FF9A7B',
          labelBackground: 'orange lighten-5',
        },
        {
          title: 'Заголовок обращения',
          subtitle: 'Обращение № 2',
          time: 'Сегодня | 16:30',
          label: 'Закрыто',
          labelColor: '#00BE08',
          labelBackground: 'green lighten-5',
        },
      ],
      chat: [],
      msg: null,
      panel: [0, 1],
    };
  },
  computed: {

  },

  methods: {
    send() {
      this.chat.push(
        {
          from: 'user',
          msg: this.msg,
        },
      );
      this.msg = null;
      this.addReply();
    },
    addFile() {
      // eslint-disable-next-line no-alert
      alert('я еще не работаю');
    },
    addReply() {
      this.chat.push({
        msg: 'Внезапно, действия представителей оппозиции, вне зависимости от их уровня',
      });
    },
  },
};
</script>

<style lang="scss" src="./style.scss"/>
